'use client';

import React, { ReactNode, createContext } from 'react';

export type GoogleOptions = {
	mapsApiKey: string;
};

export const GoogleProviderContext = createContext<GoogleOptions | null>(null);

export type GoogleProviderProps = {
	children?: ReactNode;
	options: GoogleOptions;
};

export default function GoogleProvider(props: GoogleProviderProps) {
	const { children, options } = props;

	return <GoogleProviderContext.Provider value={options}>{children}</GoogleProviderContext.Provider>;
}

export function useGoogleProvider() {
	const context = React.useContext(GoogleProviderContext);
	if (!context) {
		throw new Error('useGoogleProvider must be used within a GoogleProvider');
	}
	return context;
}
